<h1 mat-dialog-title>
    {{ 'notes.delete.title' | translate }}
</h1>
<h5>{{ 'notes.delete.message' | translate }}</h5>
<div mat-dialog-actions>
    <button mat-flat-button type="button" (click)="onCancel()">{{ 'global.cancel' | translate }}</button>
    <button mat-flat-button color="accent" (click)="onConfirm()">{{ 'global.OK' | translate }}</button>
</div>